const initialState = () => {
    return {
      applicantInfo: {
        firstName: "",
        lastName: "",
        email: "",
        dob: "",
        city: "Mississauga",
        province: "ON",
        postalCode: "",
        phoneNumber: "",
        phoneNumberType: "",
        unitNumber: "",
        streetName: "",
        streetId: "",
        streetNumber: "",
        isStreetNameValid: null,
        applicationType: "",
        residentStatus: "",
        ageStatus: "",
        physicallyDisabledStatus: "",
        netIncomeStatus: "",
        keyId: "",
        confirmationNumber: "",
        familyMemberDisabled: "",
        familySize: ""
      },
      documentsInfo: {
        incomeProofFileName: '',
        ageOrHealthProofFileName: '',
        residenceProofFileName: ''
      },
      errors: {
        uploadDocuments: {
          hasError: null,
          error: []
        },
        applicantInfo: {
          hasError: null,
          error: []
        },
        recaptcha: {
          hasError: null,
          error: []
        },
        applicationError: {
          hasError: null,
          error: []
        },
        timeoutError: {
          hasError: null,
          error: []
        }
      }
    }
  }

export default initialState;